import lodashSet from 'lodash.set';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/redux/store';

export interface GeneralStateValues {
  iReceiveDividends: Nullable<TYesOrNo>;
  iEarnInterest: Nullable<TYesOrNo>;
  iRentOutProperty: Nullable<TYesOrNo>;
}

export interface GeneralState {
  values: GeneralStateValues;
}

const initialState: GeneralState = {
  values: {
    iReceiveDividends: null,
    iEarnInterest: null,
    iRentOutProperty: null,
  },
};

const generalSlice = createSlice({
  name: 'passiveIncome/general',
  initialState,
  reducers: {
    update(state, action: PayloadAction<GeneralStateValues>) {
      state.values = action.payload;
    },
    updateKey(
      state,
      action: PayloadAction<{
        key: keyof GeneralStateValues;
        value: any;
      }>,
    ) {
      lodashSet(state, `values.${action.payload.key}`, action.payload.value);
    },
  },
});

export const { update, updateKey } = generalSlice.actions;
export default generalSlice.reducer;

export const selectGeneral = (state: RootState) =>
  state.taxQuestionnaire.income.passiveIncome.general;
